import React, { useState, useEffect } from 'react';
import { VscClose } from 'react-icons/vsc';
import { isStandalone, isIos, isMobile, canPromptInstall, promptInstall, subscribeInstall } from '../../utils/install';
import './InstallApp.css';

const DISMISS_KEY = 'kspro_install_dismissed';

// iOS share icon (square with an arrow pointing up) so users recognise the button
export const IosShareIcon = () => (
  <svg className="install-share-icon" viewBox="0 0 24 24" width="16" height="16" aria-label="Share">
    <path d="M12 3v12M8 7l4-4 4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 10H5v11h14V10h-2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IosInstructions = () => (
  <>Tap <IosShareIcon /> <b>Share</b> in the browser, then <b>Add to Home Screen</b>.</>
);

// Re-renders when the browser reports the app as installable / installed
export function useInstallState() {
  const [, force] = useState(0);
  useEffect(() => subscribeInstall(() => force(n => n + 1)), []);
  return {
    installed: isStandalone(),
    canPrompt: canPromptInstall(),
    ios:       isIos(),
  };
}

// Banner shown in mobile browsers until the app is installed or dismissed on this device
export function InstallBanner() {
  const { installed, canPrompt, ios } = useInstallState();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });

  if (installed || dismissed || !isMobile() || (!ios && !canPrompt)) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch {}
  };

  return (
    <div className="install-banner" role="dialog" aria-label="Install KSEPro">
      <img src="/icon-192.png" alt="" className="install-banner-icon" />
      <div className="install-banner-text">
        <div className="install-banner-title">Install KSEPro</div>
        <div className="install-banner-body">
          {ios ? <IosInstructions /> : 'Add the app to your home screen for notifications and quick access.'}
        </div>
      </div>
      {!ios && (
        <button className="btn-primary" onClick={() => promptInstall().then(ok => ok && dismiss())}>
          Install
        </button>
      )}
      <button className="btn-icon" title="Dismiss" onClick={dismiss}><VscClose size={16} /></button>
    </div>
  );
}
